/*
 * Bravo · Vistos recientemente en el buscador.
 *
 * Lee la cookie shopify_recently_viewed (la escribe el theme al ver una ficha o
 * abrir un quick view), pide cada producto a sections/bravo-search-recent-item y
 * muestra los primeros que sigan disponibles. Se salta:
 *   - los borrados, en borrador o fuera de la tienda online (responden 404),
 *   - los que no tienen stock (la sección no pinta nada),
 *   - el producto de la ficha en la que estás.
 *
 * Solo se ve con el buscador abierto y vacío: copia lo que hace "Búsquedas
 * populares" (snippets/bravo-popular-searches.liquid) y, si ese bloque no está,
 * aplica la misma regla por su cuenta.
 *
 * No pide nada hasta que alguien apunta a la lupa o abre el buscador. Lo ya pedido se
 * guarda durante la visita (sessionStorage) y solo se vuelve a pedir lo que cambie en la
 * cookie. Los fallos pasajeros (429, 5xx, red) no se guardan: se reintentan.
 *
 * Para revisarlo en el navegador (DevTools):
 *   - Application → Cookies: shopify_recently_viewed (handles separados por espacios).
 *   - Application → Session Storage: bravo-search-recent (se puede borrar sin problema).
 *   - Consola: customElements.get('bravo-search-recent') → debe devolver una clase.
 *   - Network, filtro "bravo-search-recent": el JS y una petición por producto.
 */
(function () {
  'use strict';

  if (customElements.get('bravo-search-recent')) return;

  var COOKIE = 'shopify_recently_viewed';
  var CACHE_KEY = 'bravo-search-recent';
  var SECTION = 'bravo-search-recent-item';

  function readHandles() {
    var row = document.cookie.split('; ').find(function (c) {
      return c.indexOf(COOKIE + '=') === 0;
    });
    if (!row) return [];
    return decodeURIComponent(row.split('=')[1] || '')
      .split(' ')
      .filter(function (h) { return h && h !== 'null'; });
  }

  function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function readCache() {
    try {
      return JSON.parse(sessionStorage.getItem(CACHE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function writeCache(cache) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache));
    } catch (e) { /* sin sessionStorage se vuelve a pedir, nada más */ }
  }

  // Una sola tanda de peticiones para todos los buscadores de la página
  var pending = {};

  function fetchItem(handle) {
    if (pending[handle]) return pending[handle];

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = root + 'products/' + encodeURIComponent(handle) + '?section_id=' + SECTION;

    // Devuelve { html, sure }. Solo se guarda en caché lo seguro: el producto pintado, sin
    // stock (200 sin tarjeta) o que ya no existe (404). Un 429, un 5xx o un fallo de red no
    // se guardan, para volver a pedirlo la próxima vez en vez de darlo por perdido.
    pending[handle] = fetch(url)
      .then(function (res) {
        if (res.status === 404) return { html: '', sure: true };
        if (!res.ok) return { html: '', sure: false };
        return res.text().then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var item = doc.querySelector('[data-bravo-search-recent-item]');
          return { html: item ? item.outerHTML : '', sure: true };
        });
      })
      .catch(function () { return { html: '', sure: false }; })
      .then(function (result) {
        delete pending[handle];
        return result;
      });

    return pending[handle];
  }

  function loadItems(handles) {
    var cache = readCache();

    return Promise.all(handles.map(function (handle) {
      if (Object.prototype.hasOwnProperty.call(cache, handle)) return { html: cache[handle], sure: true };
      return fetchItem(handle).then(function (result) {
        if (result.sure) {
          var fresh = readCache();
          fresh[handle] = result.html;
          writeCache(fresh);
        }
        return result;
      });
    }));
  }

  customElements.define('bravo-search-recent', class extends HTMLElement {
    connectedCallback() {
      this.limit = parseInt(this.dataset.limit, 10) || 6;
      this.list = this.querySelector('[data-bravo-search-recent-list]');
      this.popdown = this.closest('search-popdown');
      this.input = this.popdown && this.popdown.querySelector('input[name="q"]');
      this.popular = this.popdown && this.popdown.querySelector('[data-bravo-popular-searches]');
      // En la cabecera, "is-open" en este <details> marca cuándo se abre y se cierra la barra
      this.details = this.popdown && this.popdown.querySelector('details');
      this.renderedFor = null;

      if (!this.list || !this.popdown || !this.input) return;

      this.classList.toggle('is-last', !this.popular);

      var update = this.update.bind(this);

      if (this.popular) {
        new MutationObserver(update).observe(this.popular, { attributes: true, attributeFilter: ['class'] });
      } else {
        this.input.addEventListener('focus', update);
        this.input.addEventListener('input', update);
        new MutationObserver(update).observe(this.input, { attributes: true, attributeFilter: ['aria-expanded'] });
        if (this.details) new MutationObserver(update).observe(this.details, { attributes: true, attributeFilter: ['class', 'open'] });
      }

      // Se empieza a pedir en cuanto el cliente apunta a la lupa (ratón, teclado o dedo),
      // para que los productos estén listos al abrirla. Lo pedido queda en caché.
      var toggle = this.popdown.querySelector('[data-popdown-toggle]');
      if (toggle) {
        var prefetch = function () {
          var exclude = currentHandle();
          loadItems(readHandles().filter(function (h) { return h !== exclude; }));
        };
        ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) {
          toggle.addEventListener(ev, prefetch, { once: true, passive: true });
        });
      }

      // Por si el buscador ya estaba abierto cuando cargó este script
      this.update();
    }

    shouldShow() {
      if (this.popular) return this.popular.classList.contains('is-visible');

      // aria-expanded no cuenta: el theme lo pone en "true" al abrir aunque no haya resultados
      return this.isOpen() && this.input.value.trim() === '';
    }

    isOpen() {
      return this.details ? this.details.classList.contains('is-open') : true;
    }

    update() {
      if (!this.shouldShow()) {
        this.hide(!this.isOpen());
        return;
      }

      var exclude = currentHandle();
      var handles = readHandles().filter(function (h) { return h !== exclude; });
      var key = handles.join(' ');

      if (key === this.renderedFor) {
        this.show();
        return;
      }

      var self = this;
      loadItems(handles).then(function (results) {
        var html = results
          .map(function (r) { return r.html; })
          .filter(Boolean)
          .slice(0, self.limit)
          .join('');
        self.list.innerHTML = html;
        // Si algo falló de forma pasajera, al volver a abrir el buscador se reintenta
        var allSure = results.every(function (r) { return r.sure; });
        self.renderedFor = allSure ? key : null;
        self.hidden = html === '';
        if (self.shouldShow()) self.show();
      });
    }

    show() {
      if (this.list.children.length === 0) return;
      this.hidden = false;
      var self = this;
      requestAnimationFrame(function () { self.classList.add('is-visible'); });
    }

    // Al cerrar el buscador se oculta sin fundido, a la vez que la barra
    hide(instant) {
      if (!instant) {
        this.classList.remove('is-visible');
        return;
      }
      this.style.transition = 'none';
      this.classList.remove('is-visible');
      void this.offsetWidth;
      this.style.transition = '';
    }
  });
})();
